import React, { useEffect, useState } from "react";
import "./App.css";
import { HashRouter as Router, Route, Link } from "react-router-dom";
import { signInWithRedirect, signOut, getCurrentUser } from "@aws-amplify/auth";
// import { Authenticator } from "@aws-amplify/ui-react";
import "@aws-amplify/ui-react/styles.css";
import { Hub } from "@aws-amplify/core";
import CreateNewProxyHome from "./CreateNewProxy/CreateNewProxyHome.js";
import CreateNewProxyLibertyHome from "./CreateNewProxyLiberty/CreateNewProxyLibertyHome.js";
import pageNotFound from "./CreateNewConsumer/pageNotFound.js";
import CreateNewConsumerHome from "./CreateNewConsumer/CreateNewConsumerHome.js";
import AddGroupToExistingConsumerHome from "./AddGroupToExistingConsumer/AddGroupToExistingConsumerHome.js";
import Overview from "./Overview/OverviewHome.jsx";
import RequestsApproverNewProxy from "./Approvals/RequestsApproverNewProxy.jsx";
import RequestsApproverLiberty from "./Approvals/RequestsApproverLiberty.jsx";
import RequestsApproverAddProduct from "./Approvals/RequestsApproverAddProduct.jsx";
import { Amplify } from "aws-amplify";

const App = () => {
  const [user, setUser] = useState(null);
  const [isLoadingAuth, setIsLoadingAuth] = useState(true);
  const [username, setUsername] = useState("");
  const [isCheckingSession, setIsCheckingSession] = useState(true);
  const [redirectPath, setRedirectPath] = useState(null);
  const REDIRECT_DELAY_MS = 100;

  // Add this effect
  useEffect(() => {
    if (redirectPath) {
      // Small timeout to allow current operations to complete
      const timer = setTimeout(() => {
        window.location.hash = redirectPath;
        setRedirectPath(null);
      }, REDIRECT_DELAY_MS);
      return () => clearTimeout(timer);
    }
  }, [redirectPath]);

  const accessAuthState = async () => {
    setIsLoadingAuth(true);
    try {
      const cognitoUser = await getCurrentUser();

      setUser(cognitoUser);
    } catch (error) {
      if (error.name === "UserUnAuthenticatedException") {
        console.log(
          "No authenticated user found - this is normal before login"
        );
        const urlParams = new URLSearchParams(window.location.search);
        // Initially query params are false
        const hasCode = urlParams.has("code");
        const hasError = urlParams.has("error");
        const hasState = urlParams.has("state");

        if (!hasCode && !hasError && !hasState && !isCheckingSession) {
          console.log("Auto-redirecting to sign-in...");
          try {
            await signInWithRedirect({
              provider: { custom: "RisGatewayAzureAd" },
            });
            return; // Return early as we're redirecting
          } catch (redirectError) {
            console.error("Error during auto sign-in:", redirectError);
          }
        }
      } else {
        console.error("Unexpected error getting user:", error);
      }
      setUser(null);
    } finally {
      setIsLoadingAuth(false);
      setIsCheckingSession(false);
    }
  };

  useEffect(() => {
    const hubListenerCancel = Hub.listen("auth", ({ payload }) => {
      console.log("Hub Auth event:", payload.event);
      switch (payload.event) {
        case "customOAuthState":
          console.log("Custom OAuth state detected");
          // payload.data consists of the redirect path
          if (payload.data && payload.data !== "/") {
            setRedirectPath(payload.data);
          }
          break;
        case "signedIn":
        case "cognitoHostedUI":
          console.log("You can now access the application..!!!");
          accessAuthState();
          break;
        case "signedOut":
          console.log("User signed out via Hub event");
          setUser(null);
          setIsLoadingAuth(false);
          break;
        case "signInWithRedirect":
        case "cognitoHostedUI_success":
          console.log("Sign in successful via Hub event");
          accessAuthState();
          break;
        case "signInWithRedirect_failure":
        case "cognitoHostedUI_failure":
          console.error("Sign in failed via Hub event:", payload.data);
          setUser(null);
          setIsLoadingAuth(false);
          break;
        case "tokenRefresh":
          console.log("Token refreshed via Hub event");
          break;
        case "tokenRefresh_failure":
          console.error("Token refresh failed via Hub event:", payload.data);
          accessAuthState();
          break;
        default:
          console.log("Unhandled Hub Auth event:", payload.event);
          break;
      }
    });

    accessAuthState();
    return () => {
      hubListenerCancel(); // Clean up the Hub listener
    };
  }, []);

  useEffect(() => {
    const fetchUsername = async () => {
      if (!user) {
        setUsername("");
        return;
      }
      try {
        const { username: cognitoUsername, signInDetails } =
          await getCurrentUser();
        setUsername(cognitoUsername || signInDetails?.loginId || "Guest");
      } catch (error) {
        console.error("Error fetching username:", error);
        setUsername("Guest");
      }
    };
    fetchUsername();
  }, [user]);

  if (isLoadingAuth) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <div>Loading...</div>
      </div>
    );
  }

  if (user) {
    return (
      <div>
        <nav style={{ backgroundColor: "#fff", padding: "20px 20px" }}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div style={{ display: "flex", alignItems: "center" }}>
              <a href="/">
                <img
                  id="pfg-logo"
                  src="https://www.principalcdn.com/css/horizon/v2/logo-blk-right.svg"
                  alt="Principal logo"
                  style={{ height: "100px", padding: "10px 0" }}
                />
              </a>
            </div>

            <div style={{ display: "flex", alignItems: "center" }}>
              <div
                style={{
                  display: "flex",
                  textAlign: "center",
                  fontSize: "14px",
                  flexDirection: "column",
                  marginRight: "30px",
                }}
              >
                <div style={{ marginBottom: "5px" }}>
                  <span>
                    Looking for help? Contact the{" "}
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      href="https://principal.service-now.com/esc?id=sc_cat_item_guide&sys_id=f599dab347ac95d8291c87de536d4316"
                    >
                      API Platform Engineering team
                    </a>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </nav>
        <hr style={{ borderTop: "1px solid #ccc", margin: "0" }} />
        <div className="container" style={{ paddingTop: "30px" }}>
          <Router>
            <div>
              <Route exact path="/" component={HomePage} />
              <Route
                exact
                path="/createnewproxy"
                component={CreateNewProxyHome}
              />
              <Route
                exact
                path="/createnewproxyliberty"
                component={CreateNewProxyLibertyHome}
              />
              <Route exact path="/createnewconsumer" component={pageNotFound} />
              <Route
                exact
                path="/addgrouptoexistingconsumer"
                component={AddGroupToExistingConsumerHome}
              />
              <Route exact path="/overview" component={Overview} />
              <Route
                exact
                path="/approvals/createnewproxy"
                component={RequestsApproverNewProxy}
              />
              <Route
                exact
                path="/approvals/createnewproxyliberty"
                component={RequestsApproverLiberty}
              />
              <Route
                exact
                path="/approvals/addproduct"
                component={RequestsApproverAddProduct}
              />
            </div>
          </Router>
        </div>
      </div>
    );
  }

  return <LoginPage />; // Show login page if user is not authenticated
};

const LoginPage = () => {
  const [isSigningIn, setIsSigningIn] = useState(false);
  const [error, setError] = useState(null);

  const handleSignIn = async () => {
    try {
      setIsSigningIn(true);
      // Get the current path the user is trying to access
      const currentPath = window.location.hash.substring(1) || "/";
      await signInWithRedirect({
        provider: { custom: "RisGatewayAzureAd" },
        customState: currentPath,
      });
    } catch (error) {
      console.error("Error initiating sign-in:", error);
      setError(`Sign-in error: ${error.message}`);
      setIsSigningIn(false);
    } finally {
      setIsSigningIn(false);
    }
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        padding: "20px",
        textAlign: "center",
      }}
    >
      <img
        height="75"
        src="https://www.principalcdn.com/css/horizon/v2/logo-blk-right.svg"
        alt="Principal logo"
        style={{ marginBottom: "10px" }}
      />
      <h2>API Gateway Portal</h2>

      {error && (
        <div style={{ color: "red", marginBottom: "15px" }}>{error}</div>
      )}

      <button
        className="btn btn-primary"
        onClick={handleSignIn}
        disabled={isSigningIn}
        style={{ minWidth: "200px", marginTop: "20px" }}
      >
        {isSigningIn ? "Redirecting..." : "Sign In"}
      </button>
    </div>
  );
};

const HomePage = () => {
  const [showInfo, setShowInfo] = useState(false);
  const toggleInfo = () => {
    setShowInfo(!showInfo);
  };

  return (
    <div>
      <h1>API Gateway - Setup</h1>
      <hr />
      <div className="button-container">
        <h3>Self Service</h3>
        <Link
          to="createnewproxy"
          className="btn btn-outline-primary util-margin-right-10"
        >
          Create New Proxy
        </Link>
        <Link
          to="createnewproxyliberty"
          className="btn btn-outline-primary util-margin-right-10"
        >
          Create New Proxy Liberty
        </Link>
        <Link
          to="#" // Use hash to prevent page navigation
          className="btn btn-outline-primary util-margin-right-10"
          onClick={(e) => {
            e.preventDefault(); // Prevent the default navigation
            toggleInfo(); // Call your toggle function
          }}
        >
          Create New Consumer
        </Link>
        {showInfo && (
          <div className="info-box">
            <p>
              New API consumers should use the OAuth client management tool:{" "}
              <a
                href="https://principal.atlassian.net/wiki/x/TXVoDQ"
                target="_blank"
                rel="noopener noreferrer"
              >
                OAuth Client Management Application
              </a>{" "}
              You will also use that tool to manage any scopes your application
              requires. Once the application is created in that tool, it must be
              deployed to Apigee in all environments via the 'Deployment' tab
              Once it is deployed to Apigee in all environments, you will be
              able to submit{" "}
              <a
                href="https://apigateway.workforce.principal.com/#/addgrouptoexistingconsumer"
                target="_blank"
                rel="noopener noreferrer"
              >
                Add Proxy Group To Consumer
              </a>{" "}
              for Apigee product access.
            </p>{" "}
            <button className="close-btn" onClick={toggleInfo}>
              close
            </button>
          </div>
        )}
        <Link
          to="addgrouptoexistingconsumer"
          className="btn btn-outline-primary"
        >
          Add Proxy Group Access To Existing Consumer
        </Link>
      </div>
      <hr />
      <div>
        <h3>View Consumers and Proxies</h3>
        <Link
          to="overview"
          className="btn btn-outline-primary util-margin-right-10"
        >
          View API Gateway Data
        </Link>
      </div>
    </div>
  );
};

export default App;
